import {NetworkAPIVersion, NetworkParamType} from './network.utils';

const storyParams = {
  title: [NetworkParamType.string],
  content: [NetworkParamType.string],
  collection_id: [NetworkParamType.string],
  collection_name: [NetworkParamType.string],
  tags: [NetworkParamType.array],
  assets: [NetworkParamType.array],
  places: [NetworkParamType.array],
  clans: [NetworkParamType.array],
  tree_persons: [NetworkParamType.array],
  sources: [NetworkParamType.array],
  mention_persons: [NetworkParamType.array],
  status: [NetworkParamType.string],
  is_public: [NetworkParamType.boolean],
  order_number: [NetworkParamType.number],
  date_text: [NetworkParamType.number],
  author: [NetworkParamType.number],
};

const collectionParams = {
  cover_image: [NetworkParamType.file],
  data: [NetworkParamType.string],
};

export default {
  getFamilyWebSiteList: {
    url: 'familywebsite/?order_by=priority&order_by=-created_at',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
    params: {
      order_by: [NetworkParamType.array],
      limit: [NetworkParamType.number],
      offset: [NetworkParamType.number],
      username: [NetworkParamType.string],
    },
    authorization: true,
    fws: true,
  },
  getFamilyWebSiteListByName: {
    url: 'familywebsite/get-by-name/',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
    params: {
      username: [NetworkParamType.string],
      site_name: [NetworkParamType.string],
      keep_image_asset_id: [NetworkParamType.string],
      part: [NetworkParamType.array],
    },
    authorization: true,
    fws: true,
  },
  getMySites: {
    url: 'familywebsite/my-sites/',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
    params: {
      context_tree_id: [NetworkParamType.string],
    },
  },
  updateMySite: {
    url: 'familywebsite/{username}/',
    method: 'put',
    apiVersion: NetworkAPIVersion.v1_version,
    params: {
      is_public: [NetworkParamType.boolean],
    },
  },
  addMembers: {
    url: 'familywebsite/{username}/add-members/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'post',
    params: {
      emails: [NetworkParamType.array],
    },
  },
  deleteMember: {
    url: 'familywebsite/{username}/delete-member/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'post',
    params: {
      email: [NetworkParamType.string],
    },
  },
  searchStories: {
    url: 'api/stories/search/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      limit: [NetworkParamType.number],
      offset: [NetworkParamType.number],
      person_id: [NetworkParamType.string],
      person_ids: [NetworkParamType.string],
      clans: [NetworkParamType.string],
      operator: [NetworkParamType.string],
    },
  },
  getStories: {
    url: 'api/stories/{tree_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      limit: [NetworkParamType.number],
      offset: [NetworkParamType.number],

      q: [NetworkParamType.string],
      collections: [NetworkParamType.string],
      no_collection: [NetworkParamType.string],
      sources: [NetworkParamType.string],
      places: [NetworkParamType.string],
      tags: [NetworkParamType.string],
      clans: [NetworkParamType.string],
      tree_persons: [NetworkParamType.string],
      mention_persons: [NetworkParamType.string],
    },
  },
  getStoriesAutocomplete: {
    url: 'api/stories/{tree_id}/search/autocomplete/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      search: [NetworkParamType.string],
    },
  },
  createStory: {
    url: 'api/stories/{tree_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: storyParams,
  },
  updateStory: {
    url: 'api/stories/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'patch',
    params: storyParams,
  },
  getStory: {
    url: 'api/stories/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  deleteStory: {
    url: 'api/stories/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'delete',
  },
  getStoriesCollections: {
    url: 'api/story-collections/{tree_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  getStoriesCollection: {
    url: 'api/story-collections/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  createStoriesCollection: {
    url: 'api/story-collections/{tree_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: collectionParams,
    multipart: true,
  },
  getStoriesCollectionPDF: {
    url: 'api/story-collections/pdf/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  updateStoriesCollection: {
    url: 'api/story-collections/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'patch',
    params: collectionParams,
    multipart: true,
  },
  deleteCompilation: {
    url: 'api/story-collections/{tree_id}/{slug}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'delete',
  },
};
